import { Wallet } from '@injectivelabs/wallet-base'
import {
  ErrorType,
  UnspecifiedErrorCode,
  WalletException
} from '@injectivelabs/exceptions'
import { useChainService } from '~/composables/useChainService'

export const connect = ({
  wallet
}: {
  wallet: Wallet
}) => {
  const { walletStrategy } = useChainService()
  walletStrategy.setWallet(wallet)
}

export const getAddresses = async (): Promise<string[]> => {
  const { walletStrategy } = useChainService()

  if (walletStrategy.wallet == Wallet.WalletConnect) {
    const result = await walletStrategy.enable()
    if (!result) {
      throw new WalletException(
        new Error('There are no addresses linked in this wallet.'),
        {
          code: UnspecifiedErrorCode,
          type: ErrorType.WalletError
        }
      )
    }
  }

  const addresses = await walletStrategy.getAddresses()

  if (addresses.length === 0) {
    throw new WalletException(
      new Error('There are no addresses linked in this wallet.'),
      {
        code: UnspecifiedErrorCode,
        type: ErrorType.WalletError
      }
    )
  }

  if (!addresses.every((address) => !!address)) {
    throw new WalletException(
      new Error('There are no addresses linked in this wallet.'),
      {
        code: UnspecifiedErrorCode,
        type: ErrorType.WalletError
      }
    )
  }

  return addresses
}

export const confirm = async (address: string) => {
  const { walletStrategy } = useChainService()
  walletStrategy.getAddresses();
  return address;
}
